module.exports = __webpack_public_path__ + "img/catch01.ecace850.jpg";